import { css } from '@emotion/react';
const styles = css({
    html: {
        fontSize: '62.5%'
    },
    '#shadow-root, body': {
        margin: 0,
        padding: 0,
        overscrollBehavior: 'none',
        overflowScrolling: 'touch',
        fontSize: '1.4rem',
        fontFamily: 'Source Sans Pro, sans-serif',
        fontWeight: 400
    },
    'h1, h2, h3, h4, h5, h6': {
        margin: 0,
        padding: 0
    },
    'h1, h2': {
        fontSize: '2.4rem',
        fontWeight: 600
    },
    h2: {
        fontSize: '1.8rem'
    },
    h3: {
        fontSize: '1.4rem',
        fontWeight: 600
    },
    'h4, h5': {
        fontWeight: 400
    },
    button: {
        border: 'none',
        cursor: 'pointer',
        fontFamily: 'inherit',
        margin: 0,
        outline: 'none',
        '&:disabled, &[aria-disabled=true]': {
            opacity: 0.5,
            cursor: 'not-allowed'
        },
        '&:focus': {
            outline: 'none'
        },
        '&:focus-visible': {
            outline: '-webkit-focus-ring-color auto 1px'
        }
    },
    input: {
        fontFamily: 'inherit',
        '&:focus': {
            outline: 'none'
        }
    },
    'input[type=checkbox]': {
        '&:focus': {
            outline: 'none'
        },
        '&:focus-visible': {
            outline: '-webkit-focus-ring-color auto 1px'
        }
    },
    ul: {
        padding: 0,
        margin: 0
    },
    li: {
        listStyle: 'none',
        margin: 0,
        padding: 0
    },
    a: {
        textDecoration: 'none'
    },
    pre: {
        padding: 15,
        lineHeight: 1.45,
        borderRaddius: 3,
        background: '#f6f8fa'
    },
    strong: {
        fontWeight: 600
    },
    img: {
        width: '100%',
        maxWidth: '100%'
    }
});
export default styles;
//# sourceMappingURL=global.js.map